import React from 'react';

const MenuMiTandC = () => {

    return (
        <>
            <h2>Terms and Conditions</h2>

            <h3>
                Terms and Conditions of Pay At Table
            </h3>
            <p>
                1.	These are the terms and conditions that apply to Milano Pay at Table
                <a href="https://pay.milano.ie" target="_blank">[https://pay.milano.ie]</a> (“PaT”). Please read these terms and
                conditions carefully, together with our <a href="https://www.milano.ie/terms-and-conditions" target="_blank">Terms
                    of Use</a> and <a href="https://www.milano.ie/privacy-policy" target="_blank">Privacy Policy</a> before
                paying for your order through PaT. We recommend that you print and retain a copy for future reference.
            </p>
            <p>
                2.	By paying through PaT, you agree to be bound by these terms and conditions. If you do not accept these terms and
                conditions, you should not make payment through PaT.
            </p>
            <p>
                3.	If you have any questions relating to these terms and conditions, please contact our Customer Service team at
                <a href="mailto:customerserices@milano.ie" target="_blank">customerserices@milano.ie</a> or using the “Talk to Us” form
                on the <a href="https://www.milano.ie/our-service/talk-to-us" target="_blank">Help & Contact</a> page before you pay.
            </p>
            <p>
                4.	Our restaurants are operated by Agenbite Limited (trading as Milano) ("we", "our" or "us"). We are registered
                Ireland at 38 Main Street, Swords, Co. Dublin, Ireland.
            </p>
            <p>
                5.	You may only pay via the PaT if you are at least 16 years old or over. By paying, you warrant that you are at
                least 16 years old and you are legally capable of entering into binding contracts.
            </p>

            <h3>
                Process for Payment
            </h3>
            <p>
                6.	Please confirm the restaurant location, table number and bill items before making payment.
            </p>
            <p>
                7.	If you would like to use a voucher, please ensure you enter this before making payment. Once paid, we will not
                be able to apply a voucher to an order.
            </p>
            <p>
                8.	You can split the bill by item or by amount. Please follow the instructions on screen. You must ensure that the bill
                is settled in full.
            </p>
            <p>
                9.	When paying for any alcohol, the payee must be 18 or over.
            </p>
            <p>
                10.	You may select which method of payment you prefer. This may vary depending on the type of device you are using.
                When using a Credit or Debit Card (excludes Amex), <a href="https://support.apple.com/en-gb/HT201469" target="_blank">Apple Pay</a>
                or <a href="https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&&ldt=googlepaytos&&ldl=und" target="_blank">Google Pay</a>,
                please ensure you read the terms and conditions of use from your provider, if applicable.
            </p>
            <p>
                11.	You will receive confirmation of your payment via email. Please make sure that the email address and telephone number
                you provide are correct and functional, as our restaurant teams will not be able to provide payment confirmation.
            </p>
            <p>
                12.	If you experience technical issues when using PaT (for example, if the page freezes, payment is interrupted or you
                are charged twice for the same order), please speak to a team member.
            </p>
            <p>
                13.	For any queries or refunds, please contact our customer services using the
                <a href="https://www.milano.ie/our-service/talk-to-us" target="_blank">Help & Contact</a> page. Our restaurant teams
                are unable to process any refunds.
            </p>
            <h3>
                Your Data
            </h3>
            <p>
                14.	Our <a href="https://www.milano.ie/privacy-policy" target="_blank">Privacy Policy</a> applies to these
                terms and conditions. Please read them carefully as it contains important information about how we use your data,
                retention of your data, security measures and your rights.
            </p>
            <p>
                15.	In addition to the information stated in the privacy policy, for PaT specifically, we collect:
            </p>
            <p>
                a) information you submit to us, such as your email address, name and card details;
            </p>
            <p>
                b) location information;
            </p>
            <p>
                c) transactional information from 3rd parties we work who provide technical and payment services. We do not see your
                card details.
            </p>
            <p>
                16.	What we use it for:
            </p>
            <p>
                a) to process your payment;
            </p>
            <p>
                b) for order history;
            </p>
            <p>
                c) determine what restaurant you are dining in to get order and payment information;
            </p>
            <p>
                17.	If you want to know what information we collect and hold about you, or to exercise any of your rights, please
                contact us at <a href="mailto:feedback@milano.ie" target="_blank">feedback@milano.ie</a> or at the address in point
                4 above.
            </p>

            <h3>
                Liability
            </h3>
            <p>
                18.	We accept no responsibility for any damage or data loss caused to your device as a result of using PaT and any
                unforeseeable loss or damage. Our liability to you with respect to loss or damage you suffer as a foreseeable result
                of our breach or negligence is limited to the purchase price you paid applicable to your claim.
            </p>
            <p>
                19.	We do not exclude or limit liability for: death or personal injury caused by our negligence; fraud or fraudulent
                misrepresentation; or any liability which cannot legally be limited or excluded.
            </p>
            <p>
                20.	We will not be liable or responsible for any failure to perform, or delay in performance of, any of our obligations
                under a contract that is caused by events outside our reasonable control.
            </p>

            <h3>
                General
            </h3>
            <p>
                21.	Any failure or delay by us to enforce our rights against you is not a waiver of such rights unless explicitly
                waived by us in writing.
            </p>
            <p>
                22.	Each of the paragraphs of these terms and conditions operates separately. If any court or relevant authority
                decides that any of them are unlawful or unenforceable, the remaining paragraphs will remain in full force and effect.
            </p>
            <p>
                23.	We may transfer our rights and obligations under any contract with you to another organisation, but this will not
                affect your rights or our obligations under these terms and conditions. You may not transfer your rights or your
                obligations under these terms and conditions to another person.
            </p>
            <p>
                24.	These terms and conditions and any document expressly referred to in them represent the entire agreement in relation
                to the subject matter of any contract and supersede any prior agreement, understanding or arrangement between you, us
                and our restaurants, whether oral or in writing.
            </p>
            <p>
                25.	We reserve the right to amend these terms and conditions from time to time. Any changes we make to these terms and
                conditions will be posted on this page. You will be subject to the policies and terms and conditions in force at the
                time that you use PaT, unless any change to those policies or these terms and conditions is required to be made by law
                or governmental authority.
            </p>
            <p>
                26.	No one other than a party to these terms and conditions shall have any right to enforce any of its terms and
                conditions.
            </p>
            <p>
                27.	These terms and conditions and any dispute or claim arising out of or in connection with PaT will be governed by
                English law and shall be subject to jurisdiction of the courts of England and Wales.
            </p>
        </>
    );
}

export default MenuMiTandC;